export const SUBSCRIPTION_ICONS = {
    'free': 'time-outline',
    'trainer_basic': 'hand-left-outline',
    'trainer_20': 'thumbs-up-outline',
    'trainer_30': 'flame-outline',
    'trainer_40': 'medal-outline',
    'athlete_basic': 'medal-outline'
}